module.exports = __webpack_public_path__ + "images/facebook.svg";


//////////////////
// WEBPACK FOOTER
// ./images/facebook.svg
// module id = 21
// module chunks = 1